/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown>, company: NonNullable<unknown> }} Cover_Letters_Job_At_CompanyInputs */

const en_cover_letters_job_at_company = /** @type {(inputs: Cover_Letters_Job_At_CompanyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} at ${i?.company}`)
};

const de_cover_letters_job_at_company = /** @type {(inputs: Cover_Letters_Job_At_CompanyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} bei ${i?.company}`)
};

const fr_cover_letters_job_at_company = /** @type {(inputs: Cover_Letters_Job_At_CompanyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} chez ${i?.company}`)
};

const es_cover_letters_job_at_company = /** @type {(inputs: Cover_Letters_Job_At_CompanyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} en ${i?.company}`)
};

const it_cover_letters_job_at_company = /** @type {(inputs: Cover_Letters_Job_At_CompanyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} presso ${i?.company}`)
};

const nl_cover_letters_job_at_company = /** @type {(inputs: Cover_Letters_Job_At_CompanyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} bij ${i?.company}`)
};

const pl_cover_letters_job_at_company = /** @type {(inputs: Cover_Letters_Job_At_CompanyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} w ${i?.company}`)
};

const fi_cover_letters_job_at_company = /** @type {(inputs: Cover_Letters_Job_At_CompanyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} yrityksessä ${i?.company}`)
};

const da_cover_letters_job_at_company = /** @type {(inputs: Cover_Letters_Job_At_CompanyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} hos ${i?.company}`)
};

const sv_cover_letters_job_at_company = /** @type {(inputs: Cover_Letters_Job_At_CompanyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} på ${i?.company}`)
};

/**
* | output |
* | --- |
* | "{title} at {company}" |
*
* @param {Cover_Letters_Job_At_CompanyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_job_at_company = /** @type {((inputs: Cover_Letters_Job_At_CompanyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Job_At_CompanyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_job_at_company(inputs)
	if (locale === "fr") return fr_cover_letters_job_at_company(inputs)
	if (locale === "es") return es_cover_letters_job_at_company(inputs)
	if (locale === "it") return it_cover_letters_job_at_company(inputs)
	if (locale === "nl") return nl_cover_letters_job_at_company(inputs)
	if (locale === "pl") return pl_cover_letters_job_at_company(inputs)
	if (locale === "fi") return fi_cover_letters_job_at_company(inputs)
	if (locale === "da") return da_cover_letters_job_at_company(inputs)
	if (locale === "sv") return sv_cover_letters_job_at_company(inputs)
	return en_cover_letters_job_at_company(inputs)
});